// Import Sentry first so it initialises before any other module runs and can
// capture startup errors (init happens as a side-effect of this import).
import './sentry.js';
import './components/app-main.js';
import { initAnalytics } from './analytics.js';

// Start product analytics (no-op when no PostHog key is configured)
initAnalytics();

// Initialize the app
document.addEventListener('DOMContentLoaded', () => {
  const appContainer = document.getElementById('app');
  
  if (!appContainer) return;
  // De kaart van een labopdracht in een eigen venster (tweede scherm): alleen de kaart, zonder
  // menu of inlog. Hij krijgt alles van de pagina die hem opende; zie utils/lab-kaart.js.
  if (window.location.pathname === '/kaartvenster') {
    import('./components/lab-kaartvenster.js').then(() => {
      appContainer.innerHTML = '<lab-kaartvenster></lab-kaartvenster>';
    });
    return;
  }
  // De boorprofielen van een labopdracht in een eigen venster; zie utils/lab-profielen.js.
  if (window.location.pathname === '/profielvenster') {
    import('./components/lab-profielvenster.js').then(() => {
      appContainer.innerHTML = '<lab-profielvenster></lab-profielvenster>';
    });
    return;
  }
  appContainer.innerHTML = '<app-main></app-main>';
});

// Handle global errors
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason);
});

window.addEventListener('error', (event) => {
  console.error('Global error:', event.error);
});
